import {classInstance} from '@/shared/helpers/helpers';

export class Counter {
	private counter: HTMLElement;
	private inputField: HTMLInputElement;
	private minusButton: HTMLInputElement;
	private plusButton: HTMLInputElement;
	private min: number;
	private max: number;
	private value: number;

	constructor(element: HTMLElement) {
		if (!element) return;

		this.counter = element;
		this.inputField = this.counter.querySelector('.counter__input');
		this.minusButton = this.counter.querySelector('.counter__button--dec');
		this.plusButton = this.counter.querySelector('.counter__button--inc');
		this.min = parseInt(this.inputField.min, 10);
		this.max = parseInt(this.inputField.max, 10);
		this.value = parseInt(this.inputField.value, 10) || 0; 

		this.init();
	}

	private setButtonsState = (): void => {
		[this.minusButton, this.plusButton].forEach((button) => button.removeAttribute('disabled'));
		if (this.value === this.min) this.minusButton.setAttribute('disabled', '');
		if (this.value === this.max) this.plusButton.setAttribute('disabled', '');
	};

	private setValue = (newValue): void => {
		if (newValue < this.min) this.value = this.min;
		else if (newValue > this.max) this.value = this.max;
		else this.value = newValue;
		this.inputField.value = `${this.value}`;
		this.inputField.dispatchEvent(new CustomEvent('change'));
		this.setButtonsState();
	};

	private handleClick = ({ target }): void => {
		const { type } = target.dataset;
		if (type === 'dec') this.setValue(this.value -= 1);
		if (type === 'inc') this.setValue(this.value += 1);
	};

	private handleInput = ({ target }): void => {
		if (target.value && !target.value.match(/^-?[0-9]\d*?$/)) target.value = `${ this.value }`;
		else this.setValue(parseInt(target.value, 10));
	};

	private handleBlur = ({ target }): void => {
		if (target.value) return;
		this.setValue(this.min);
	};

	init = (): void => {
		classInstance.set(this.counter, { counter: this });

		this.counter.addEventListener('click', this.handleClick);
		this.inputField.addEventListener('input', this.handleInput);
		this.inputField.addEventListener('blur', this.handleBlur);
	};
}
